import { useSelector } from "react-redux";

import { useIntl } from "react-intl-compat";

import { selectAuthAccessToken } from "../../../../components/src/app-main/selectors/auth.selectors";
import { selectProfileSSOid } from "../../../../components/src/app-main/selectors/profile.selectors";
import {
  ListingEditorLayout,
  ListingEditorLayoutSkeleton,
} from "../components/ListingEditorLayout";

import { ListingRulesForm } from "./ListingRulesForm";
import { useListingRulesData } from "./useListingRulesData";

type ListingRulesPageProps = {
  params: { listingId: string };
};

const ListingRulesPage = ({ params: { listingId } }: ListingRulesPageProps) => {
  const accessToken = useSelector(selectAuthAccessToken);
  const ssoId = useSelector(selectProfileSSOid);
  const intl = useIntl();
  const { listing, isFetching, space } = useListingRulesData({ listingId });

  // requireAuth's redirect is a side effect, not a render gate
  // — bail out here so nothing real renders for a
  // logged-out request while that navigation is in flight.
  if (!accessToken) {
    return null;
  }

  const isLoading = isFetching || !listing || !space || !ssoId;

  // Ensure only listing owners can access this page
  if (!isLoading && listing.ownerId !== ssoId) {
    window.location.href = "/mylistings";
    return null;
  }

  return (
    <div
      className="ps-container-lg-margin ps-container-fixed"
      data-testid="rules-page"
    >
      <div className="ps-row">
        <div className="col-xs-12">
          {isLoading ? (
            <ListingEditorLayoutSkeleton />
          ) : (
            <ListingEditorLayout
              listing={listing}
              space={space}
              testIdPrefix="rules-page"
              pageHeader={intl.formatMessage({
                id: "hosting.listing_rules.page_header",
                defaultMessage: "Rules",
              })}
            >
              <ListingRulesForm listing={listing} />
            </ListingEditorLayout>
          )}
        </div>
      </div>
    </div>
  );
};

export { ListingRulesPage };
